const TOAST_IMG_MAP = {
  success: 'success',
  error: 'toast-error',
  info: 'info',
};

export default TOAST_IMG_MAP;
